/**
 * Customer Record data model and serialization helpers.
 *
 * Shape: { name: string, emails: string[], apiKeyIds: string[], accessToken: string|null, supportPortalLink: string|null, supportTicketsEnabled: boolean }
 */

const createEmptyCustomer = (name) => ({
  name,
  emails: [],
  apiKeyIds: [],
  accessToken: null,
  supportPortalLink: null,
  isMediproCustomer: true,
  isAcaproCustomer: false,
  supportTicketsEnabled: false
})

const serializeCustomer = (customer) => ({
  name: customer.name,
  emails: customer.emails || [],
  apiKeyIds: customer.apiKeyIds || [],
  accessToken: customer.accessToken || null,
  supportPortalLink: customer.supportPortalLink || null,
  isMediproCustomer: customer.isMediproCustomer !== false,
  isAcaproCustomer: customer.isAcaproCustomer || false,
  supportTicketsEnabled: customer.supportTicketsEnabled === true
})

const deserializeCustomer = (data) => ({
  name: data.name,
  emails: Array.isArray(data.emails) ? data.emails : [],
  apiKeyIds: Array.isArray(data.apiKeyIds) ? data.apiKeyIds : [],
  accessToken: data.accessToken || null,
  supportPortalLink: data.supportPortalLink || null,
  isMediproCustomer: data.isMediproCustomer !== false,
  isAcaproCustomer: data.isAcaproCustomer || false,
  supportTicketsEnabled: data.supportTicketsEnabled === true
})

export { createEmptyCustomer, serializeCustomer, deserializeCustomer }
